import { isRouteErrorResponse, useRouteError } from 'react-router';
import { Button, ButtonLink } from '@/components/ui/Button';
import { Mascot } from '@/components/ui/Mascot';
import { useI18n } from '@/i18n/context';

export function RouteError() {
  const error = useRouteError();
  const { t } = useI18n();
  const notFound = isRouteErrorResponse(error) && error.status === 404;
  if (!notFound) console.error(error);
  return (
    <main
      id="main"
      className="mx-auto flex min-h-dvh max-w-md flex-col items-center justify-center gap-4 px-4 text-center"
    >
      <Mascot mood="think" className="size-32" />
      <h1 className="text-2xl font-black">{notFound ? t('errors.notFound') : t('errors.title')}</h1>
      {!notFound && <p className="text-ink-muted">{t('errors.body')}</p>}
      <div className="flex flex-wrap justify-center gap-3">
        <ButtonLink to="/" reloadDocument>
          {t('errors.goHome')}
        </ButtonLink>
        {!notFound && (
          <Button variant="secondary" onClick={() => window.location.reload()}>
            {t('errors.reload')}
          </Button>
        )}
      </div>
    </main>
  );
}

export function NotFound(): never {
  throw new Response('Not found', { status: 404 });
}
